export default {
  app: {
    name: 'Nexus DCIM',
    subtitle: '数据中心基础设施管理',
  },
  nav: {
    overview: '运行总览',
    tenants: '运营主体',
    customers: '客户管理',
    datacenters: '机房管理',
    racks: '机架管理',
    devices: '设备资产',
    switches: '交换机管理',
    images: '镜像管理',
    installSettings: '装机配置',
    ipam: 'IP 管理',
    users: '用户与权限',
    agents: 'Agent 状态',
    remoteSessions: '远控会话',
    discovery: '自动发现',
    storage: '存储健康',
    provisioning: '自动装机',
    lifecycle: '生命周期',
    audit: '审计日志',
    api: 'API 文档',
  },
  common: {
    create: '新建',
    edit: '编辑',
    save: '保存',
    cancel: '取消',
    search: '搜索',
    actions: '操作',
    loading: '加载中',
    logout: '退出登录',
    language: '语言',
    status: '状态',
    all: '全部',
    noData: '暂无数据',
    success: '操作成功',
    records: '条记录',
  },
  login: {
    title: '欢迎回来',
    intro: '统一管理多机房空间、容量与资产',
    username: '用户名',
    password: '密码',
    submit: '登录',
    hint: '使用管理员账号登录',
    failed: '登录失败，请检查用户名和密码',
  },
  overview: {
    eyebrow: '基础设施态势',
    title: '数据中心运行总览',
    description: '从一个视图管理机房、机架和关键资产。',
    datacenters: '机房',
    racks: '机架',
    devices: '设备',
    utilization: '资产概况',
    healthy: '平台服务正常',
    quick: '快捷入口',
    startNow: '立即开始',
    viewDocs: '查看文档',
    tagSecurity: '稳定安全',
    tagGlobal: '全球节点',
    tagEnterprise: '企业级服务',
    tagCollaboration: '高速协同',
  },
  datacenter: {
    title: '机房管理',
    description: '统一维护物理站点与运行状态',
    code: '机房编码',
    name: '名称',
    address: '地址',
    timezone: '时区',
    status: '运行状态',
    active: '运行中',
    maintenance: '维护中',
    inactive: '已停用',
    create: '新建机房',
  },
  rack: {
    codePlaceholder: '例如：SHA-01-R02 或 R02',
    codeDuplicateHint: '当前机房 {datacenter} 已存在机架编码 {code}，请换一个编码',
    title: '机架管理',
    description: '维护机架容量和供电上限',
    code: '机架编码',
    name: '名称',
    datacenter: '所属机房',
    units: 'U 位总数',
    power: '额定功率 (W)',
    enabledAt: '机柜启用时间',
    enabledAtPlaceholder: '选择启用日期',
    enabled: '已启用',
    notEnabled: '未填写',
    create: '新建机架',
  },
  device: {
    title: '设备资产',
    description: '跟踪设备位置、身份与生命周期',
    assetTag: '资产标签',
    name: '设备名称',
    datacenter: '机房',
    rack: '机架',
    placement: '上架位置',
    vendorModel: '厂商 / 型号',
    status: '状态',
    power: '功率 (W)',
    create: '新建设备',
    planned: '计划中',
    installed: '已装机',
    in_service: '运行中',
    maintenance: '维护中',
    retired: '已退役',
  },
  user: {
    title: '用户与权限',
    description: '通过角色分配最小必要权限',
    username: '用户名',
    displayName: '显示名称',
    locale: '语言',
    roles: '角色',
    active: '启用',
    password: '初始密码',
    create: '新建用户',
  },
  tenant: {
    title: '运营主体',
    description: '仅超级管理员使用；当前单 IDC 模式保留一个默认运营主体即可',
    code: '主体编码',
    name: '主体名称',
    type: '业务类型',
    domestic: '国内',
    overseas: '海外',
    all: '全部包括',
    create: '新建运营主体',
    edit: '编辑运营主体',
    deleteTitle: '删除运营主体',
    deleteConfirm: '确定删除运营主体“{name}”吗？仅无关联业务数据的主体可以删除；不会删除其历史日志。',
    defaultProtected: '默认运营主体不能删除',
    active: '启用',
    suspended: '暂停',
    archived: '归档',
  },
  customer: {
    title: '客户管理',
    description: '维护独立客户账号和服务器归属，与后台管理员账号完全分开',
    tenant: '所属租户',
    code: '客户编码',
    name: '姓名',
    account: '账号',
    password: '密码',
    passwordKeep: '留空表示不修改密码',
    passwordRequired: '8–32 位，首次配置必须填写',
    email: '邮箱',
	phone: '电话',
	profileStatus: '资料状态',
	profileComplete: '资料完整',
	profileIncomplete: '待完善',
    create: '新建客户',
    active: '启用',
    inactive: '停用',
  },
  lifecycle: {
    title: '资产生命周期',
    description: '跟踪采购、入库、上架、出租、维护和报废',
    states: '生命周期状态',
    create: '新增事件',
    device: '设备 ID',
    transition: '状态流转',
    reason: '原因',
    createdAt: '创建时间',
    from: '原状态',
    to: '目标状态',
    optionalDevice: '可选，填写设备 UUID',
  },
  audit: {
    title: '审计日志',
    description: '查看 HTTP 操作日志和业务审计事件',
    operations: '操作日志',
    events: '审计事件',
    path: '路径',
    statusCode: '状态码',
    result: '结果',
    eventType: '事件类型',
    severity: '级别',
    summary: '摘要',
  },
  agent: {
    title: 'Whale Agent 状态',
    description: '查看机房 Agent 在线状态、能力声明和版本',
    total: 'Agent 总数',
    online: '在线',
    supportedVersions: '支持版本',
    name: 'Agent 名称',
    publicIP: '公网 IP',
    version: '版本',
    lastSeen: '最后心跳',
    fingerprint: '证书指纹',
    collectorDiagnostics: '采集诊断',
    noDiagnostics: '暂无采集诊断上报',
    collectorHistory: '采集历史',
    latestRuns: '最近记录',
    noCollectorHistory: '暂无采集历史',
    reportedAt: '上报时间',
    provider: '采集器',
    errorCount: '错误数',
    warningCount: '告警数',
    tool: '工具',
    command: '命令',
    installed: '已安装',
    allowed: '白名单允许',
    required: '必需',
    checks: '检查项',
    error: '错误',
    degraded: '异常',
    offline: '离线',
    disabled: '禁用',
  },
  discovery: {
    title: '服务器自动发现',
    description: '通过 Whale Agent 扫描新接入服务器，确认后写入正式资产',
    createJob: '新建发现任务',
    jobs: '发现任务',
    results: '发现结果',
    scanScope: '扫描范围 JSON',
    invalidJson: '扫描范围必须是合法 JSON',
    agentReady: 'Agent 已满足发现任务条件',
    agentNotReady: 'Agent 暂不满足发现任务条件',
    agentCollectorDegraded: '采集诊断处于异常状态，请先修复必需工具或命令白名单。',
    agentMustBeOnline: 'Agent 必须在线且健康，才能创建发现任务。',
    serial: '序列号',
    confidence: '置信度',
    profile: '硬件画像',
    confirm: '确认入库',
    ignore: '忽略',
    pending: '等待中',
    running: '运行中',
    succeeded: '成功',
    failed: '失败',
    canceled: '已取消',
    pending_confirm: '待确认',
    duplicate: '疑似重复',
    confirmed: '已确认',
    ignored: '已忽略',
  },
  storage: {
    title: '存储与 RAID 健康',
    description: '查看服务器 RAID 卡、物理盘、逻辑卷和 SMART 健康状态',
    selectDevice: '选择服务器',
    controllers: '控制器',
    disks: '物理盘',
    volumes: '逻辑卷',
    totalCapacity: '总容量',
    totalWritten: '累计写入量',
    averageHealth: '平均健康度',
    health: '健康度',
    unhealthy: '异常磁盘',
    vendor: '厂商',
    model: '型号',
    type: '类型',
    firmware: '固件',
    slot: '槽位',
    media: '介质',
    capacity: '容量',
    temperature: '温度',
    wear: '磨损',
    smart: 'SMART',
    volume: '卷名称',
    diskCount: '磁盘数',
    stripe: '条带',
    ok: '正常',
    warning: '告警',
    critical: '严重',
    unknown: '未知',
    rebuilding: '重建中',
  },
  error: {
    FORBIDDEN: '没有执行此操作的权限',
    VALIDATION_ERROR: '提交内容不符合要求',
    AGENT_INVALID: 'Agent 信息不符合要求，请检查名称、公网 IP 和所属机房',
    NETWORK_AGENT_MISMATCH: '所选 Agent 不属于当前机房，请重新选择同机房 Agent',
    NETWORK_AGENT_UNAVAILABLE: '所选机房 Agent 离线或不可用，请选择在线 Agent 后重试',
    NETWORK_APPLY_LOCKED: '真实下发需要在线且已验证的交换机驱动',
    NETWORK_CREDENTIAL_MISSING: '交换机管理凭据未保存，请先保存账号和密码',
    NETWORK_CREDENTIAL_UNSUPPORTED: '当前只支持 SSH 密码方式采集交换机',
    NETWORK_DEVICE_DISABLED: '这台交换机已停用，不能采集或下发配置',
    NETWORK_DEVICE_IN_USE: '这台交换机还有采集或配置任务未结束',
    NETWORK_DEVICE_NOT_DISABLED: '删除交换机前请先停用',
    NETWORK_DEVICE_INVENTORY_FAILED: '交换机只读采集失败',
    NETWORK_DEVICE_LIST_FAILED: '交换机列表读取失败',
    NETWORK_DATACENTER_TENANT_MISSING: '所选机房缺少运营主体，请先保存机房或联系管理员修复机房归属',
    NETWORK_DRIVER_INVALID: '交换机驱动不支持，请检查品牌、型号和匹配驱动',
    NETWORK_OPERATION_FAILED: '交换机操作失败',
    NETWORK_PROTOCOL_DISABLED: '交换机未启用 SSH 或 Telnet 协议',
    NETWORK_RACK_MISMATCH: '所选机柜不属于同一机房，请重新选择机柜',
    NETWORK_RESOURCE_NOT_FOUND: '交换机资源不存在或已删除',
    NETWORK_SNMP_PROFILE_MISSING: 'SNMP 配置未保存',
    NETWORK_SNMP_SECRET_MISSING: 'SNMP 凭据不完整，请填写用户名/Community 和密码',
    NETWORK_SSH_DISABLED: '交换机未启用 SSH 协议',
    NETWORK_TENANT_MISMATCH: '交换机、机房或机柜不属于同一运营主体',
    NETWORK_CHANGE_IN_PROGRESS: '这台交换机正在执行另一项真实操作，请等待完成后再试',
    REMOTE_AGENT_UNAVAILABLE: '当前机房没有在线且支持远控的 Whale Agent',
    REMOTE_SESSION_ALREADY_ACTIVE: '这台服务器已有远控会话，系统正在复用现有通道，请稍后重试',
    REMOTE_SESSION_NOT_READY: '机房 Agent 正在建立远控通道，请稍后重试',
    REMOTE_SESSION_CLOSED: '远控会话已关闭或已过期',
    REMOTE_SESSION_TOKEN_INVALID: '远控连接凭证无效或已过期',
    REMOTE_OPERATION_FAILED: '远控操作失败，请稍后重试',
    REMOTE_BMC_CREDENTIAL_REQUIRED: 'BMC密码未保存，请在连接信息或远控页保存 BMC账号密码',
    REMOTE_BMC_CREDENTIAL_INVALID: 'BMC密码不可用，请更新 BMC账号密码',
    REMOTE_POWER_OPERATION_ACTIVE: '这台服务器正在执行远控或电源操作，请完成后再试',
    REMOTE_POWER_ACTION_INVALID: '不支持这个电源操作',
    REMOTE_CREDENTIAL_STORE_UNAVAILABLE: '控制卡凭据服务暂不可用',
    REMOTE_IDRAC_AUTH_FAILED: '控制卡自动登录失败，请检查账号和密码',
    CUSTOMER_ACCOUNT_CONFLICT: '客户账号已存在，请更换账号后重试',
    IMAGE_REPO_UPLOAD_FILE_REQUIRED: '没有收到镜像文件，请重新选择本地镜像后再上传',
    IMAGE_REPO_UPLOAD_TOO_LARGE: '镜像文件太大，请改用服务器导入方式',
    IMAGE_REPO_UPLOAD_PARSE_FAILED: '镜像上传请求解析失败，请查看后面的具体原因',
    IMAGE_REPO_UPLOAD_INVALID: '镜像上传内容不符合要求，请检查文件类型、名称和版本',
    IMAGE_REPO_UPLOAD_FAILED: '镜像上传失败，请稍后重试或改用服务器导入',
    IPAM_POOL_OVERLAP: '这个 IP 段已存在，或与已有地址池重叠，请换一个网段',
    IPAM_POOL_CONFLICT: '这个 IP 地址池已存在或无法创建，请检查网段',
    RACK_CONFLICT: '当前机房内机架编码已存在，请换一个编码',
    RACK_UNIT_CONFLICT: '所选机架 U 位已被占用',
    INVALID_PLACEMENT: '设备超出机架可用范围',
    default: '操作失败，请稍后重试',
  },
}
